import { render, staticRenderFns } from "./RouteSharePage.vue?vue&type=template&id=2179d0d8&scoped=true&"
import script from "./RouteSharePage.vue?vue&type=script&lang=js&"
export * from "./RouteSharePage.vue?vue&type=script&lang=js&"
import style0 from "./RouteSharePage.vue?vue&type=style&index=0&id=2179d0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179d0d8",
  null
  
)

export default component.exports